<template>
  <div class="container">
    <div class="search-entry" @click="openSearchPopup">
      <div class="search-entry-main">
        <van-icon name="search" />
        <span class="search-entry-text">{{ searchDisplayText }}</span>
      </div>
      <span class="search-entry-action">
        {{ activeFilterCount > 0 ? `${activeFilterCount}项筛选` : "去筛选" }}
      </span>
    </div>

    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="member-item" v-for="item in localMemberList" :key="item.id" @click="handleMemberClick(item)">
        <div class="member-avatar">
          <img :src="item.avatarLink || defaultAvatar" alt="" />
        </div>
        <div class="member-info">
          <div class="member-top">
            <div class="member-name">
              <span class="name">{{ item.nickName || formatSerial(item.serialNumber) }}</span>
              <span class="serial">ID:{{ formatSerial(item.serialNumber) }}</span>
            </div>
            <!-- <div class="member-age">{{ calculateAge(item.birthday) }}岁</div> -->
          </div>
          <div class="member-tags">
            <span class="tag-item">{{ item.hometown || "未知" }}</span>
            <span class="tag-item">{{ getEducationText(item.education) }}</span>
            <span class="tag-item">{{ item.height }}cm</span>
            <span class="tag-item">{{ calculateAge(item.birthday) }}岁</span>
          </div>
        </div>
        <div class="member-arrow" v-if="isMember">
          <van-icon name="arrow" color="#CCCCCC" />
        </div>
      </div>

      <div class="list-empty" v-if="localMemberList.length === 0 && !loading">
        <div class="list-empty-icon">🔎</div>
        <div class="list-empty-text">暂无搜索结果</div>
        <div class="list-empty-desc">试试重新调整筛选条件</div>
      </div>
    </van-list>

    <van-popup v-model="showSearchPopup" position="right" class="search-popup">
      <div class="search-popup-page">
        <div class="search-popup-header">
          <div class="popup-title">搜索筛选</div>
          <button class="popup-close" @click="showSearchPopup = false">✕</button>
        </div>

        <div class="search-popup-body">
          <div class="keyword-card">
            <div class="keyword-label">关键词搜索</div>
            <div class="keyword-field">
              <van-icon name="search" />
              <input v-model.trim="keyword" type="text" placeholder="输入昵称/编号">
            </div>
          </div>

          <div class="filter-section">
            <div class="section-title">基础筛选</div>
            <div class="selector-grid">
              <div class="selector-cell" @click="areaCheck = true">
                <span class="selector-label">籍贯</span>
                <span class="selector-value over-omit" :class="{ placeholder: !hometown }">{{ hometown || "不限" }}</span>
              </div>
              <div class="selector-cell" @click="showPicker('education')">
                <span class="selector-label">学历</span>
                <span class="selector-value" :class="{ placeholder: !education }">{{ education || "不限" }}</span>
              </div>
              <div class="selector-cell selector-cell-range">
                <span class="selector-label">出生年份</span>
                <div class="range-row">
                  <span @click="showRangePicker('year1')" class="range-value"
                    :class="{ placeholder: !minimumBirthday }">{{ minimumBirthday || "最小"
                    }}</span>
                  <span class="range-sep">-</span>
                  <span @click="showRangePicker('year2')" class="range-value"
                    :class="{ placeholder: !maximumBirthday }">{{ maximumBirthday || "最大"
                    }}</span>
                </div>
              </div>
              <div class="selector-cell selector-cell-range">
                <span class="selector-label">身高 (cm)</span>
                <div class="range-row">
                  <span @click="showRangePicker('height1')" class="range-value"
                    :class="{ placeholder: !minimumHeight }">{{ minimumHeight || "最小" }}</span>
                  <span class="range-sep">-</span>
                  <span @click="showRangePicker('height2')" class="range-value"
                    :class="{ placeholder: !maximumHeight }">{{ maximumHeight || "最大" }}</span>
                </div>
              </div>
            </div>
            <div class="selector-full">
              <div class="selector-cell selector-cell-full" @click="showPicker('interestDesc')">
                <span class="selector-label">兴趣爱好</span>
                <span class="selector-value over-omit" :class="{ placeholder: !interestDesc }">{{ interestDesc || "不限"
                }}</span>
              </div>
            </div>
          </div>

          <div class="filter-section">
            <div class="section-title">标签筛选</div>
            <div class="selector-grid">
              <div class="selector-cell" @click="showTagPicker('personality')">
                <span class="selector-label">性格标签</span>
                <span class="selector-value over-omit" :class="{ placeholder: !personalityTagsText }">
                  {{ personalityTagsText || "不限" }}
                </span>
              </div>
              <div class="selector-cell" @click="showTagPicker('spouse')">
                <span class="selector-label">择偶标签</span>
                <span class="selector-value over-omit" :class="{ placeholder: !spouseTagsText }">
                  {{ spouseTagsText || "不限" }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="search-popup-footer">
          <button class="footer-btn footer-btn-reset" @click="handleReset">重置</button>
          <button class="footer-btn footer-btn-confirm" @click="handleSearch(true)">确定筛选</button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showPickerPopup" round position="bottom" :style="{ height: '40%' }">
      <van-picker :columns="pickerColumns" :default-index="pickerDefaultIndex" @cancel="onPickerCancel"
        @confirm="onPickerConfirm" show-toolbar />
    </van-popup>

    <van-popup v-model="areaCheck" position="bottom" :style="{ height: '50%' }">
      <van-area v-model="hometownCode" :area-list="areaData" :columns-num="areaNum" @cancel="onAreaCencel"
        @confirm="onAreaConfirm">
        <template #title>
          <span class="popup-area-title"><van-checkbox v-model="preciseCity" shape="square" @click.stop @change="onPreciseCityChange">精确到市</van-checkbox></span>
        </template>
      </van-area>
    </van-popup>

    <van-popup v-model="showTagPopup" position="bottom" :style="{ height: '60%' }">
      <div class="tag-picker">
        <div class="tag-picker-header">
          <span @click="cancelTags">取消</span>
          <span class="title">{{ tagPickerTitle }}</span>
          <span @click="confirmTags">确定</span>
        </div>
        <div class="tag-list">
          <span v-for="tag in currentTagList" :key="tag.id" class="tag-item"
            :class="{ selected: selectedTags.includes(tag.id) }" @click="toggleTag(tag)">{{ tag.tagName }}</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { areaList } from "@vant/area-data";
import { getEncounterMemberList, getAllTags } from "@/api/user";
import defaultAvatar from "@/assets/defaultPhoto.png";

export default {
  name: "MoreFilter",
    props: {
      initialState: {
        type: Object,
        default: null
      }
    },
  data() {
    return {
      defaultAvatar,
      areaData: areaList,
      keyword: "",
      education: "",
      minimumBirthday: "",
      maximumBirthday: "",
      minimumHeight: "",
      maximumHeight: "",
      hometown: "",
      hometownCode: "",
      preciseCity: false,
      areaNum: 1,
      areaCheck: false,
      showSearchPopup: false,
      showTagPopup: false,
      personalityTags: [],
      spouseTags: [],
      selectedPersonalityTags: [],
      selectedSpouseTags: [],
      interestDesc: "",
      personalityTagsText: "",
      spouseTagsText: "",
      showPickerPopup: false,
      pickerColumns: [],
      pickerDefaultIndex: 0,
      pickerType: "",
      currentTagList: [],
      currentTagType: "",
      selectedTags: [],
      allTags: [],
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      localMemberList: [],
      dateData: [],
      highColumns: []
    };
  },
  computed: {
    ...mapGetters(["baseInfo", "role"]),
    isMember() {
      return this.role === "Member";
    },
    tagPickerTitle() {
      switch (this.currentTagType) {
        case "personality":
          return "性格标签";
        case "spouse":
          return "择偶标签";
        default:
          return "选择标签";
      }
    },
    educationOptions() {
      return ["不限", "大专及以上", "本科及以上", "硕士及以上", "博士及以上"];
    },
    interestDescOptions() {
      return [
        "不限",
        "球类运动（篮球、乒乓球、羽毛球等）",
        "体育运动（跑步、跳绳、健身等）",
        "户外活动（旅游、登山）",
        "文艺类（唱歌、跳舞、乐器）",
        "娱乐类（逛街、看电影、看书）",
        "冒险类（潜水、攀岩）",
        "智力类（拼图、拆装）",
        "游戏类（桌游、网游）",
        "休闲类（园艺、写生、摄影）",
        "美食类（火锅、烧烤等）",
        "烹饪类（中餐、西餐、糕点）",
        "其他"
      ];
    },
    activeFilterCount() {
      const filters = [
        this.keyword,
        this.education,
        this.minimumBirthday,
        this.maximumBirthday,
        this.minimumHeight,
        this.maximumHeight,
        this.hometown,
        this.interestDesc,
        this.personalityTagsText,
        this.spouseTagsText
      ];
      return filters.filter(Boolean).length;
    },
    searchDisplayText() {
      if (this.keyword) {
        return this.keyword;
      }
      const summaryList = [
        this.education,
        this.hometown,
        this.interestDesc,
        this.personalityTagsText,
        this.spouseTagsText
      ].filter(Boolean);
      if (summaryList.length) {
        return summaryList.slice(0, 2).join(" · ");
      }
      return "搜索昵称/编号/筛选条件";
    }
  },
  created() {
    this.loadTags();
    const currentYear = new Date().getFullYear();
    for (let i = 1900; i <= currentYear; i++) {
      this.dateData.push(i);
    }
    for (let index = 110; index < 240; index++) {
      this.highColumns.push(index);
    }
    if (!this.initialState) this.loadData();
      if (this.initialState) this.restoreState(this.initialState);
  },
  methods: {
    openSearchPopup() {
      this.showSearchPopup = true;
    },
    formatSerial(serialNumber) {
      if (!serialNumber) return "0000";
      return String(serialNumber).padStart(4, "0");
    },
    calculateAge(birthday) {
      if (!birthday) return 0;
      const today = new Date();
      const birthDate = new Date(birthday);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    getEducationText(education) {
      const educationMap = {
        1: "大专",
        2: "本科",
        3: "硕士",
        4: "博士",
        5: "高中及以下"
      };
      return educationMap[education] || "未知";
    },
    showRangePicker(category) {
      switch (category) {
        case "year1":
          this.showPicker('start');
          break;
        case "year2":
          this.showPicker('end');
          break;
        case "height1":
          this.showPicker('minHeight');
          break;
        case "height2":
          this.showPicker('maxHeight');
          break;
      }
      // if (category === 'year') {
      //   if (!this.minimumBirthday) {
      //     this.showPicker('start');
      //   } else {
      //     this.showPicker('end');
      //   }
      // } else if (category === 'height') {
      //   if (!this.minimumHeight) {
      //     this.showPicker('minHeight');
      //   } else {
      //     this.showPicker('maxHeight');
      //   }
      // }
    },
    showPicker(type) {
      this.pickerType = type;
      switch (type) {
        case "education":
          this.pickerColumns = this.educationOptions;
          break;
        case "minHeight":
        case "maxHeight":
          this.pickerColumns = this.highColumns;
          this.pickerDefaultIndex = 50;
          break;
        case "start":
        case "end":
          this.pickerColumns = this.dateData;
          this.pickerDefaultIndex = 95;
          break;
        case "interestDesc":
          this.pickerColumns = this.interestDescOptions;
          break;
      }
      this.showPickerPopup = true;
    },
    onPickerCancel() {
      this.showPickerPopup = false;
      switch (this.pickerType) {
        case "education":
          this.education = '';
          break;
        case "minHeight":
          this.minimumHeight = '';
          break;
        case "maxHeight":
          this.maximumHeight = '';
          break;
        case "start":
          this.minimumBirthday = '';
          break;
        case "end":
          this.maximumBirthday = '';
          break;
        case "interestDesc":
          this.interestDesc = '';
          break;
      }
    },
    onPickerConfirm(value) {
      this.showPickerPopup = false;
      switch (this.pickerType) {
        case "education":
          this.education = value;
          break;
        case "minHeight":
          if (this.maximumHeight && this.maximumHeight < value) {
            this.minimumHeight = this.maximumHeight;
            this.maximumHeight = value;
            return;
          }
          this.minimumHeight = value;
          break;
        case "maxHeight":
          if (this.minimumHeight && this.minimumHeight > value) {
            this.maximumHeight = this.minimumHeight;
            this.minimumHeight = value;
            return;
          }
          this.maximumHeight = value;
          break;
        case "start":
          if (this.maximumBirthday && this.maximumBirthday < value) {
            this.minimumBirthday = this.maximumBirthday;
            this.maximumBirthday = value;
            return;
          }
          this.minimumBirthday = value;
          break;
        case "end":
          if (this.minimumBirthday && this.minimumBirthday > value) {
            this.maximumBirthday = this.minimumBirthday;
            this.minimumBirthday = value;
            return;
          }
          this.maximumBirthday = value;
          break;
        case "interestDesc":
          this.interestDesc = value;
          break;
      }
    },
      onPreciseCityChange(val) {
        this.areaNum = val ? 2 : 1;
      },

    onAreaCencel() {
      this.areaCheck = false;
      this.hometown = "";
    },
    onAreaConfirm(values) {
      this.areaCheck = false;
      if (this.preciseCity) {
        this.hometown = values.map(v => v.name).filter(n => n).join("/");
      } else {
        this.hometown = values[0] ? values[0].name : "";
      }
    },
    async loadTags() {
      try {
        const res = await getAllTags();
        if (res.code === 20000) {
          // this.allTags = [{ id: '0', tagName: '不限', tagType: 1, sortOrder: 0, isSystem: false }];
          // this.allTags = this.allTags.concat(res.data || []);
          this.allTags = res.data || [];
          this.personalityTags = this.allTags;
          this.spouseTags = this.allTags;
        }
      } catch (error) {
        console.error("加载标签失败", error);
      }
    },
    showTagPicker(type) {
      this.currentTagType = type;
      switch (type) {
        case "personality":
          this.currentTagList = this.personalityTags;
          this.selectedTags = [...this.selectedPersonalityTags];
          break;
        case "spouse":
          this.currentTagList = this.spouseTags;
          this.selectedTags = [...this.selectedSpouseTags];
          break;
      }
      this.showTagPopup = true;
    },
    toggleTag(tag) {
      const index = this.selectedTags.indexOf(tag.id);
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(tag.id);
      }
    },
    cancelTags() {
      this.showTagPopup = false;
      switch (this.currentTagType) {
        case "personality":
          this.selectedPersonalityTags = [];
          this.selectedTags = [];
          this.personalityTagsText = "";
          break;
        case "spouse":
          this.selectedSpouseTags = [];
          this.selectedTags = [];
          this.spouseTagsText = "";
          break;
      }
    },
    confirmTags() {
      this.showTagPopup = false;
      switch (this.currentTagType) {
        case "personality":
          this.selectedPersonalityTags = [...this.selectedTags];
          this.personalityTagsText = this.selectedPersonalityTags.length > 0 ? `已选${this.selectedPersonalityTags.length}项` : "";
          break;
        case "spouse":
          this.selectedSpouseTags = [...this.selectedTags];
          this.spouseTagsText = this.selectedSpouseTags.length > 0 ? `已选${this.selectedSpouseTags.length}项` : "";
          break;
      }
    },
    handleReset() {
      this.keyword = "";
      this.education = "";
      this.minimumBirthday = "";
      this.maximumBirthday = "";
      this.minimumHeight = "";
      this.maximumHeight = "";
      this.hometown = "";
      this.hometownCode = "";
      this.preciseCity = false;
      this.selectedPersonalityTags = [];
      this.selectedSpouseTags = [];
      this.interestDesc = "";
      this.personalityTagsText = "";
      this.spouseTagsText = "";
    },
    handleSearch(closePopup) {
      this.page = 1;
      this.finished = false;
      this.localMemberList = [];
      if (closePopup) {
        this.showSearchPopup = false;
      }
      this.loadData();
    },
    onLoad() {
      this.loadData();
    },
    buildRequestParams() {
      const currentSex = this.baseInfo.sex;
      const targetSex = this.baseInfo.spouseSex ? Number(this.baseInfo.spouseSex) : (currentSex === 1 ? 2 : 1);
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        sex: targetSex
      };

      // if (this.keyword) {
      //   if (/^\d+$/.test(this.keyword)) {
      //     params.serialNumber = parseInt(this.keyword, 10);
      //   } else {
      //     params.name = this.keyword;
      //   }
      // }
      params.keyword = this.keyword;
      if (this.education && this.education !== "不限") {
        const educationValueMap = {
          "大专及以上": 1,
          "本科及以上": 2,
          "硕士及以上": 3,
          "博士及以上": 4
          
        };
        params.education = educationValueMap[this.education];
      }
      if (this.minimumBirthday) {
        params.minimumBirthday = new Date(this.minimumBirthday + "-01-01").toISOString();
      }
      if (this.maximumBirthday) {
        params.maximumBirthday = new Date(this.maximumBirthday + "-12-31").toISOString();
      }
      if (this.minimumHeight) {
        params.minimumHeight = this.minimumHeight;
      }
      if (this.maximumHeight) {
        params.maximumHeight = this.maximumHeight;
      }
      if (this.hometown) {
        params.hometown = this.hometown;
      }
      if (this.selectedPersonalityTags.length > 0) {
        params.personalityTagIds = this.selectedPersonalityTags;
      }
      if (this.selectedSpouseTags.length > 0) {
        params.spouseRequirementTagIds = this.selectedSpouseTags;
      }
      if (this.interestDesc) {
        const index = this.interestDescOptions.indexOf(this.interestDesc);
        params.descriptionOfPersonalInterests = index + 1;
      }

      return params;
    },
    async loadData() {
      if (this.finished) return;
      this.loading = true;
      try {
        const res = await getEncounterMemberList(this.buildRequestParams());
        if (res.code === 20000) {
          const newList = res.data.items || [];
          const memberMap = new Map(this.localMemberList.map(item => [item.id, item]));
          newList.forEach(item => {
            memberMap.set(item.id, item);
          });
          this.localMemberList = Array.from(memberMap.values());
          if (newList.length < this.pageSize) {
            this.finished = true;
          } else {
            this.page++;
          }
        } else {
          this.finished = true;
        }
      } catch (error) {
        console.error("加载数据失败", error);
        this.finished = true;
      } finally {
        this.loading = false;
      }
    },
    handleMemberClick(item) {
      if (this.isMember) {
        this.$router.push({ path: `/detailInformation/${item.id}` });
      } else {
        this.$toast("非会员不可查看会员详情");
      }
      },
      getState() {
        return {
          keyword: this.keyword,
          education: this.education,
          minimumBirthday: this.minimumBirthday,
          maximumBirthday: this.maximumBirthday,
          minimumHeight: this.minimumHeight,
          maximumHeight: this.maximumHeight,
          hometown: this.hometown,
          hometownCode: this.hometownCode,
          preciseCity: this.preciseCity,
          interestDesc: this.interestDesc,
          selectedPersonalityTags: [...this.selectedPersonalityTags],
          selectedSpouseTags: [...this.selectedSpouseTags],
          personalityTagsText: this.personalityTagsText,
          spouseTagsText: this.spouseTagsText,
          localMemberList: this.localMemberList,
          page: this.page,
          finished: this.finished,
          scrollTop: document.documentElement.scrollTop || document.body.scrollTop || 0
        };
      },
      restoreState(state) {
        if (!state) return;
        this.keyword = state.keyword || "";
        this.education = state.education || "";
        this.minimumBirthday = state.minimumBirthday || "";
        this.maximumBirthday = state.maximumBirthday || "";
        this.minimumHeight = state.minimumHeight || "";
        this.maximumHeight = state.maximumHeight || "";
        this.hometown = state.hometown || "";
        this.hometownCode = state.hometownCode || "";
        this.preciseCity = state.preciseCity || false;
        this.interestDesc = state.interestDesc || "";
        this.selectedPersonalityTags = state.selectedPersonalityTags || [];
        this.selectedSpouseTags = state.selectedSpouseTags || [];
        this.personalityTagsText = state.personalityTagsText || "";
        this.spouseTagsText = state.spouseTagsText || "";
        this.localMemberList = state.localMemberList || [];
        this.page = state.page || 1;
        this.finished = state.finished || false;
        this.loading = false;
        this.$nextTick(() => {
          window.scrollTo(0, state.scrollTop || 0);
        });
      }
    }
};
</script>

<style lang="less" scoped>
@import url('../../style/theme-variables.less');
@import url('../../style/prototype-common.less');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  width: 100%;
  position: relative;
  padding: 0.8rem;
}

.search-entry {
  .prototype-card();
  min-height: 2.7rem;
  padding: 0.78rem 0.85rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  margin-bottom: 0.85rem;
}

.search-entry-main {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .van-icon {
    flex-shrink: 0;
    font-size: 0.82rem;
    color: @text-tertiary;
  }
}

.search-entry-text {
  min-width: 0;
  flex: 1;
  font-size: 0.64rem;
  line-height: 0.92rem;
  color: @text-secondary;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-entry-action {
  flex-shrink: 0;
  padding: 0.22rem 0.5rem;
  border-radius: 999px;
  background: rgba(255, 138, 154, 0.12);
  font-size: 0.54rem;
  line-height: 0.78rem;
  color: @primary-color;
  font-weight: @font-weight-semibold;
}

.member-item {
  width: 100%;
  margin-bottom: 0.8rem;
  background: #FFFFFF;
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  padding: 0.8rem;
  position: relative;
  box-shadow: @shadow-card;

  .member-avatar {
    width: 3.2rem;
    height: 3.2rem;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    margin-right: 0.8rem;
    background: #f5f5f5;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .member-info {
    flex: 1;
    min-width: 0;

    .member-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.4rem;

      .member-name {
        min-width: 0;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.3rem;

        .name {
          font-size: 0.7rem;
          font-weight: 500;
          color: #333333;
        }

        .serial {
          font-size: 0.56rem;
          color: #999999;
        }
      }

      .member-age {
        flex-shrink: 0;
        font-size: 0.6rem;
        color: #A402F7;
        background: rgba(164, 2, 247, 0.1);
        padding: 0.1rem 0.4rem;
        border-radius: 0.5rem;
      }
    }

    .member-tags {
      display: flex;
      flex-wrap: wrap;

      .tag-item {
        font-size: 0.56rem;
        color: #666666;
        background: #f5f5f5;
        padding: 0.1rem 0.35rem;
        border-radius: 0.2rem;
        margin-right: 0.3rem;
        margin-bottom: 0.2rem;
      }
    }
  }

  .member-arrow {
    margin-left: 0.5rem;
  }
}

.list-empty {
  .prototype-card();
  padding: 1.8rem 1rem;
  text-align: center;
}

.list-empty-icon {
  font-size: 1.7rem;
  line-height: 1.9rem;
}

.list-empty-text {
  margin-top: 0.45rem;
  font-size: 0.78rem;
  line-height: 1.08rem;
  color: @text-primary;
  font-weight: @font-weight-bold;
}

.list-empty-desc {
  margin-top: 0.2rem;
  font-size: 0.58rem;
  line-height: 0.84rem;
  color: @text-tertiary;
}

.search-popup {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
}

.search-popup-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #FFFFFF 0%, #FFF6F8 16%, #FFFFFF 100%);
}

.search-popup-header {
  padding: 1rem 0.9rem 0.85rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.popup-title {
  font-size: 1rem;
  line-height: 1.35rem;
  color: @text-primary;
  font-weight: @font-weight-bold;
}

.popup-close {
  width: 1.9rem;
  height: 1.9rem;
  border: none;
  border-radius: 0.7rem;
  background: @bg-gray;
  font-size: 0.95rem;
  color: @text-primary;
}

.search-popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 0 0.8rem 1rem;
}

.keyword-card {
  .prototype-card();
  padding: 0.85rem;
  margin-bottom: 0.8rem;
}

.keyword-label {
  font-size: 0.58rem;
  line-height: 0.84rem;
  color: @text-tertiary;
  margin-bottom: 0.55rem;
}

.keyword-field {
  width: 100%;
  height: 2.1rem;
  padding: 0 0.7rem;
  border-radius: 999px;
  background: @bg-gray;
  display: flex;
  align-items: center;
  gap: 0.45rem;

  .van-icon {
    flex-shrink: 0;
    font-size: 0.8rem;
    color: @text-tertiary;
  }

  input {
    width: 100%;
    border: none;
    background: transparent;
    font-size: 0.64rem;
    color: @text-primary;
    outline: none;
  }
}

.filter-section {
  .prototype-card();
  padding: 0.85rem;
  margin-bottom: 0.8rem;
}

.section-title {
  font-size: 0.74rem;
  line-height: 1rem;
  color: @text-primary;
  font-weight: @font-weight-bold;
  margin-bottom: 0.75rem;
}

.selector-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.6rem;
}

.selector-full {
  margin-top: 0.6rem;
}

.selector-cell-full {
  width: 100%;
  box-sizing: border-box;
}

.selector-cell-range {
  cursor: pointer;

  .range-row {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    margin-top: 0.15rem;
  }

  .range-value {
    font-size: 0.58rem;
    line-height: 0.84rem;
    color: @text-primary;
    font-weight: @font-weight-medium;
    min-width: 0;
    flex: 1;
    text-align: center;

    &.placeholder {
      color: @text-tertiary;
      font-weight: @font-weight-normal;
    }
  }

  .range-sep {
    flex-shrink: 0;
    font-size: 0.52rem;
    color: @text-tertiary;
  }
}

.selector-cell {
  min-height: 3.1rem;
  padding: 0.65rem 0.7rem;
  border-radius: @radius-large;
  background: @bg-gray;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.selector-label {
  font-size: 0.54rem;
  line-height: 0.78rem;
  color: @text-tertiary;
}

.selector-value {
  font-size: 0.64rem;
  line-height: 0.92rem;
  color: @text-primary;
  font-weight: @font-weight-medium;

  &.placeholder {
    color: @text-tertiary;
    font-weight: @font-weight-normal;
  }
}

.over-omit {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-popup-footer {
  padding: 0.7rem 0.8rem calc(0.7rem + env(safe-area-inset-bottom));
  display: flex;
  gap: 0.65rem;
  background: #FFFFFF;
  box-shadow: 0 -6px 20px rgba(26, 26, 26, 0.06);
}

.footer-btn {
  flex: 1;
  height: 2rem;
  border: none;
  border-radius: 999px;
  font-size: 0.66rem;
  font-weight: @font-weight-semibold;
}

.footer-btn-reset {
  background: @bg-gray;
  color: @text-secondary;
}

.footer-btn-confirm {
  background: @gradient-primary;
  color: @text-light;
  box-shadow: @shadow-btn;
}

.popup-area-title {
  font-size: 14px;
}

.tag-picker {
  background: #FFFFFF;
  height: 100%;
  display: flex;
  flex-direction: column;

  .tag-picker-header {
    display: flex;
    justify-content: space-between;
    padding: 0.8rem;
    border-bottom: 1px solid #F0F0F0;

    .title {
      font-size: 0.8rem;
      font-weight: 600;
      color: #333333;
    }

    span {
      font-size: 0.7rem;
      color: #A402F7;
    }
  }

  .tag-list {
    flex: 1;
    overflow-y: auto;
    padding: 0.8rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: flex-start;
    align-content: flex-start;

    .tag-item {
      padding: 0.4rem 0.8rem;
      background: #F5F5F5;
      border-radius: 0.8rem;
      font-size: 0.7rem;
      color: #666666;
      border: 1px solid transparent;

      &.selected {
        background: rgba(164, 2, 247, 0.1);
        color: #A402F7;
        border-color: #A402F7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/encounter/MoreFilter.vue